module.exports = __webpack_public_path__ + "img/frame-night.316acba5.png";